import SdkDisclosureRow from './SdkDisclosureRow'

export default SdkDisclosureRow
